module.exports = __webpack_public_path__ + "static/img/b_4.166b75d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b_4.jpg
// module id = 253
// module chunks = 0 1 2 3 4 5 6 7 8 9